import { render, staticRenderFns } from "./ArrowIconBlack.vue?vue&type=template&id=68183fc2"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68183fc2')) {
      api.createRecord('68183fc2', component.options)
    } else {
      api.reload('68183fc2', component.options)
    }
    module.hot.accept("./ArrowIconBlack.vue?vue&type=template&id=68183fc2", function () {
      api.rerender('68183fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ArrowIconBlack.vue"
export default component.exports